import axios from "../api/axiosInstance";

export const GetAllGrouping = async () => {
    return await axios.get("/Grouping/GetGroupingList");
};

export const GetGroupingById = async (id) => {
    return await axios.get("/Grouping/GetGroupingById", {
        params: { id }
    });
};

export const GetGroupingByName = async (name) => {
    return await axios.get("/Grouping/GetGroupingByName", {
        params: { name }
    });
};
export const AddGrouping = async (model) => {
    return await axios.post("/Grouping/AddGrouping", model);
};

export const UpdateGrouping = async (model) => {
    return await axios.post("/Grouping/UpdateGrouping", model);
};

export const RemoveGrouping = async (id) => {
    return await axios.post("/Grouping/RemoveGrouping", null, {
        params: { id }
    });
};